import { getAvailableLaunchConfigurations } from "../../../catalog/launch/catalogLaunchConfigurations";
import { resolveCatalogLaunch } from "../../../catalog/utils/catalogLaunch";

export const LIVE_MODERATION_LAUNCH_CONFIGURATION_ID =
  "moderate-session";

const LIVE_ACTIVITY_ORDER = new Map([
  ["overall-severity", 0],
  ["grbas", 1],
  ["capev", 2],
  ["capevr", 3],
]);

function hasLiveModerationLaunchConfiguration(
  entry,
  options = {}
) {
  return getAvailableLaunchConfigurations(entry, options).some(
    (configuration) =>
      configuration?.id ===
      LIVE_MODERATION_LAUNCH_CONFIGURATION_ID
  );
}

export function isLiveModerationCatalogEntry(
  entry,
  options = {}
) {
  if (!entry || entry.primaryType !== "activity") {
    return false;
  }

  if (
    !hasLiveModerationLaunchConfiguration(entry, options)
  ) {
    return false;
  }

  const launch =
    resolveCatalogLaunch(entry, {
      launchConfigurationId:
        LIVE_MODERATION_LAUNCH_CONFIGURATION_ID,
    });

  return Boolean(launch?.type === "route" && launch.to);
}

export function listLiveModerationCatalogEntries(
  entries = [],
  options = {}
) {
  return (Array.isArray(entries) ? entries : [])
    .filter((entry) =>
      isLiveModerationCatalogEntry(entry, options)
    )
    .sort((left, right) => {
      const leftOrder =
        LIVE_ACTIVITY_ORDER.get(left?.slug) ??
        Number.POSITIVE_INFINITY;
      const rightOrder =
        LIVE_ACTIVITY_ORDER.get(right?.slug) ??
        Number.POSITIVE_INFINITY;

      if (leftOrder !== rightOrder) {
        return leftOrder - rightOrder;
      }

      const leftTitle = String(left?.title || left?.slug || "");
      const rightTitle = String(
        right?.title || right?.slug || ""
      );

      return leftTitle.localeCompare(rightTitle);
    });
}
